

const NothingSelected = () => {
  return (
    <div className="nothing_main-content">
        <p>Seleccione una entrada
            <br/>
            o agrege una nueva
        </p>
        <i className="far fa-star fa-4x mt-5"></i>
    </div>
  )
}

export default NothingSelected